import QRCode from "react-qr-code"
import phonepe_svg from '../media/phonepe.svg'
import gpay_svg from '../media/GPay.svg'
import bhim_svg from '../media/BHIM.svg'
import paytm_svg from '../media/paytm.svg'
import logo_img from '../media/logo.svg'
import './DepositMain.css'

const UPIPage = ({ paymentImg,
    orderDetails,
    pendingConfirmation,
    config,
    ispaid,
    qrRef,
    redirectLinks,
    showUTRNumber,
    redirectToPaymentApp,
    openWithSelectedApps,
    setOrderDetails,
    cancelButton,
    getBase64,
    fileValue,
    setFileValue,
    copyToClipboard,
    image,
    removeImg,
    togglePreview,
    errMsg
}) => {

    return <div className="content">
        {window.innerWidth <= 480 && <>
            {!ispaid && <button id="PayNow1" className="popup-button" type="button" onClick={() => { showUTRNumber(true) }} >I have Paid</button>}
            {ispaid && <button id="PayNow1" className="popup-button" type="button" onClick={() => { showUTRNumber(false) }} ><i className="bi bi-arrow-left" style={{ color: "#fff" }}></i> Back To Order Details</button>}
            {redirectLinks?.currency === "INR" && <><button id="PayNow1" className="popup-button" type="button" onClick={() => { redirectToPaymentApp() }}>
                <span className="image_cover" style={{ left: "10px" }}><img className="btn_imgs" src={paytm_svg} alt="" /></span>
                <span className="image_cover" style={{ left: "30px" }}><img className="btn_imgs" src={phonepe_svg} alt="" /></span>
                <span className="image_cover" style={{ left: "50px" }}><img className="btn_imgs" src={gpay_svg} alt="" /></span>
                <span className="image_cover" style={{ left: "70px" }}><img className="btn_imgs" src={bhim_svg} alt="" /></span>Pay With App <i className="bi bi-chevron-right" style={{ color: "#fff", fontSize: "20px", position: "absolute", right: "15px", top: "10px" }}></i></button>
                <div className="payment_Apps">
                    <button id="paytmmp" className="btn paytm_btn" onClick={(e) => { openWithSelectedApps(e) }}><img src={paytm_svg} alt="" /></button>
                    <button id="phonepe" className="btn phonepe_btn" onClick={(e) => { openWithSelectedApps(e) }}><img src={phonepe_svg} alt="" /></button>
                    <button id="tez" className="btn bhim_btn" onClick={(e) => { openWithSelectedApps(e) }}><img src={gpay_svg} alt="" /></button>
                </div>
            </>}
            {ispaid && <button id="ConfirmPayment1" disabled={!orderDetails?.utr && !fileValue} onClick={() => { pendingConfirmation() }}>Confirm Payment <i className="bi bi-check-circle-fill" style={{ color: "#fff" }}></i></button>}
            {ispaid && <> {orderDetails.transactionInstrument === "UPI" ? <div className="form-group" id="UTRNumber">
                <label>Enter UTR Number:</label>
                <input type="number" minLength="12" placeholder="UTR Number" value={orderDetails?.utr ? orderDetails?.utr : "N/A"} onChange={(e) => { setOrderDetails({ ...orderDetails, utr: e.target.value }) }} maxLength="12" id="utr" name="utr" required />
            </div> :
                <div className="qr-code-container1 mt-2">
                    <div className="">
                        <h6>Please upload receipt after payment.</h6>
                        {/* <div className="form-group" id="UTRNumber">
                            {orderDetails.utr && orderDetails.utr !== orderDetails.orderId && <b className="text-center text-danger">UTR must match with OrderId</b> }
                            <label>Enter UTR:</label>
                            <input type="text" placeholder="UTR Number" value={orderDetails?.utr} onChange={(e) => { setOrderDetails({ ...orderDetails, utr: e.target.value }) }} id="utr" name="utr" required />
                        </div> */
                        }
                        <h6 style={{ fontSize: "14px", fontWeight: "700" }} className="text-center ms-auto me-auto text-danger">{errMsg}</h6>
                        {!fileValue && <div className=" d-flex justify-content-left mt-2" style={{ width: "90%" }} id="paymentProofDiv">
                            <input type="file" className="mb-4" placeholder="Upload Payment Proof" accept="image/png,image/jpg,image/jpeg" style={{ color: "#000", display: "none" }} onChange={(e) => { getBase64(e); setFileValue(e.target.value?.split("\\").pop()) }} name="paymentProof" id="paymentProof" />
                            <div id="fileName" onClick={() => document.getElementById("paymentProof").click()}>
                                <button className="green_btn">Choose File</button>
                                <span style={{ color: "#777" }}>{fileValue ? fileValue : 'Upload Payment Proof'}</span>
                            </div>
                        </div>}
                        {
                            fileValue && <div className="img_preview text-center mt-3 ms-auto me-auto df">
                                <button title="Remove" className="remove_img fa-solid fa-xmark" onClick={removeImg}></button>
                                <div onClick={togglePreview}>Preview <i className="fa fa-eye"></i></div>
                                <img src={'data:image/png;base64,' + image} style={{ cursor: "pointer" }} height="100px" width="100px" alt="" onClick={togglePreview} />
                            </div>
                        }
                        <div className="text-center">
                            {/* <button id="PayNow1" className="popup-button w-50 p-0 ms-auto me-auto" disabled={!(paymentImg)} onClick={() => { pendingConfirmation() }}>Confirm Payment</button> */}
                        </div>
                    </div>
                </div>}
            </>
            }


            {!ispaid && <div className="qr-code-container1 fcol mt-2">
                <div>
                    <h4 style={{ fontWeight: "700", color: "#777" }}>QR code</h4>
                    <p style={{ fontSize: "14px" }}>Use it once-reusing it will result in loss of funds</p>
                </div>
                {redirectLinks?.currency === "INR" && !redirectLinks?.qrCode ? <div ref={qrRef} className="qrCover1 ms-auto me-auto">
                    {/* {window.innerWidth <= 480 && <p className="mobile-text">Scan this QR Code to pay via UPI</p>} */}
                    {config && <QRCode size="200" value={config} />}
                </div> :
                    <img height={200} src={'data:image/png;base64,' + redirectLinks?.qrCode} alt="" />}
                <p className="description mt-3">Pay with UPI app or scan one time QR code.</p>
                <p className="description">After payment return and click "I have paid" button.</p>
                <div className="form-group mt-3">
                    <label>Order ID:{orderDetails?.orderId ? orderDetails?.orderId : "N/A"}</label>
                </div>
                <div className="form-group amount_grp p-0">
                    <label>AMOUNT: <span className="amount" style={{ fontSize: '20px' }}>{redirectLinks?.currencySymbol ? redirectLinks?.currencySymbol : redirectLinks?.currency} {orderDetails?.amount ? Number(orderDetails?.amount).toFixed(2) : "N/A"}</span></label>

                </div>
            </div>}
            <div className="deposit_page"> <div className="text-center header_tag mb-4">
                <button title="Cancel" className="back_button fa-solid fa-xmark" onClick={cancelButton}></button>
                <div className="d-flex align-items-center"><img src={logo_img} height="30px" alt="" />&nbsp; <h4 className="title m-0" style={{ fontSize: "28px", fontWeight: "700" }}> P2way</h4></div>
                {<p id="timer"><span id="countdown">00:00</span></p>}
            </div>
                {!ispaid && <div className="form-container">

                    {/* <div className="form-group" style={{ position: "relative" }}>
                    <label>UPI ID:</label>
                    <input type="text" placeholder="UPI ID" id="upiId" value={orderDetails?.upiId ? orderDetails?.upiId : "N/A"} disabled />
                    <div style={{ position: "absolute", bottom: "10%", right: "4%" }}>
                        <CopyToClipboard text={orderDetails?.upiId}>
                            <i className="fa-regular fa-copy " style={{ fontSize: "25px", color: "#888", cursor: "pointer" }}></i>
                        </CopyToClipboard>
                    </div>
                </div> */}

                    {/* <div className="form-group">
                    <label>Merchant ID:</label>
                    <input type="text" id="merchantId" placeholder="Merchant ID" value={orderDetails?.merchantId ? orderDetails?.merchantId : "N/A"} disabled />
                </div> */}
                    {/* <div className="errormessage">
                    <p id='dataMessage'></p>
                </div> */}
                    {/* <button onClick={()=>{window.location.href="gpay://pay?pa=rminizlp322107@ypbiz&pn=PhonePeMerchant&mc=0000&mode=02&purpose=00&tr=860f9851-cdfc-4a67-9d80-3a90b69ecdad&tn=26739c12-5028-40b5-9f35-c21ee439fa44&am=13.0"}}>Test</button> */}

                    {/* <button id="Cancel" onClick={cancelButton} type="submit">Cancel</button> */}
                </div>}
            </div>
        </>}

        {window.innerWidth > 480 && <>
            <div className="deposit_page pt-0 pb-0">
                <div className="text-center header_tag w-75 ms-auto me-auto">
                    <button title="Cancel" className="back_button1 fa-solid fa-xmark" onClick={cancelButton}></button>
                    <div className="d-flex align-items-center"><img src={logo_img} height="30px" alt="" />&nbsp; <h4 className="title m-0" style={{ fontSize: "28px", fontWeight: "700" }}> P2way</h4></div>
                    {<p id="timer"><span id="countdown">00:00</span></p>}
                </div>
                {redirectLinks?.message && <p id="bonus1" className="text-center">{redirectLinks?.message}</p>}
                {/* <p id="bonus1" className="text-center">You have got a bonus of 0.01</p> */}
                <div className="order_box justify-content-center">
                    <div className="qrBox w-75">
                        <h1 id="TimeStamp_check"></h1>
                        <div className="qr-code-container1 fcol" style={{ backgroundColor: "#FFF" }}>
                            <div>
                                <h4 style={{ fontWeight: "700", color: "#777" }}>QR code</h4>
                                <p style={{ fontSize: "14px", marginBottom: "0" }}>Use it once-reusing it will result in loss of funds</p>
                            </div>
                            <div ref={qrRef} className="qrCover1 ms-auto me-auto">
                                {/* {window.innerWidth <= 480 && <p className="mobile-text">Scan this QR Code to pay via UPI</p>} */}
                                {redirectLinks?.currency === "INR" && !redirectLinks?.qrCode ? <QRCode size="200" value={config} /> : <img height={250} src={'data:image/png;base64,' + redirectLinks?.qrCode} />}
                                {/* <p style={{fontSize:"20px",fontWeight:"700",color:"#777",marginBottom:"0px",textAlign:"center"}}>{orderDetails?.upiId?orderDetails?.upiId:"N/A"}<CopyToClipboard text={orderDetails?.upiId}>
                                <i className="fa-regular fa-copy " style={{ fontSize: "25px", color: "#888", cursor: "pointer" }}></i>
                            </CopyToClipboard></p> */}
                            </div>
                            <p className="description text-center">Pay with UPI app or scan one time QR code.</p>
                            {/* <p className="description text-center">After payment return and click "I have paid" button</p> */}
                            <div className="form-group">
                                <label>Order ID:<span className="text-dark" style={{ fontSize: "14px" }}>{orderDetails?.orderId ? orderDetails?.orderId : "N/A"}</span></label>
                            </div>
                            <div className="form-group">
                                <label>Amount: <span style={{ color: '#1DAB87' }} id="amount">{orderDetails?.amount ? `${redirectLinks?.currency ? redirectLinks?.currency : "N/A"} ${Number(orderDetails?.amount).toFixed(2)}` : "N/A"}</span></label>
                                {/* <input type="text" style={{ color: '#1DAB87' }} id="amount" placeholder="Amount" value={orderDetails?.amount ? `₹ ${Number(orderDetails?.amount).toFixed(2)}` : "N/A"} disabled /> */}
                            </div>
                            {/* {!ispaid && <button id="PayNow1" className="popup-button" type="button" onClick={() => { showUTRNumber(true) }} >I have Paid</button>} */}

                            {orderDetails.transactionInstrument === "UPI" ? (ispaid && <> <div className=" d-flex w-100 justify-content-center" id="UTRNumber">
                                {/* <label >Enter UTR Number:</label> */}
                                <input type="text" minLength="12" className="w-50 floating" placeholder="Enter UTR Number" value={orderDetails?.utr} onChange={(e) => { ((/^[1-9][0-9]*$/.test(e.target.value) || e.target.value === '') && setOrderDetails({ ...orderDetails, utr: e.target.value })) }} maxLength="12" id="utr" name="utr" required />
                            </div>
                                <button id="PayNow1" className="popup-button w-50 p-0 ms-auto me-auto" disabled={!(orderDetails?.utr)} onClick={() => { pendingConfirmation() }}>Confirm Payment</button>
                            </>)
                                :
                                <div className="text-center mt-2">
                                    <div className="">
                                        <h6>Please upload receipt after payment.</h6>
                                        {/* <div className="form-group" id="UTRNumber">
                            {orderDetails.utr && orderDetails.utr !== orderDetails.orderId && <b className="text-center text-danger">UTR must match with OrderId</b> }
                            <label>Enter UTR:</label>
                            <input type="text" placeholder="UTR Number" value={orderDetails?.utr} onChange={(e) => { setOrderDetails({ ...orderDetails, utr: e.target.value }) }} id="utr" name="utr" required />
                        </div> */
                                        }
                                        <h6 style={{ fontSize: "14px", fontWeight: "700" }} className="text-center ms-auto me-auto text-danger">{errMsg}</h6>
                                        {!fileValue && <div className=" d-flex justify-content-left mt-2" style={{ width: "90%" }} id="paymentProofDiv">
                                            <input type="file" className="mb-4" placeholder="Upload Payment Proof" accept="image/png,image/jpg,image/jpeg" style={{ color: "#000", display: "none" }} onChange={(e) => { getBase64(e); setFileValue(e.target.value?.split("\\").pop()) }} name="paymentProof" id="paymentProof" />
                                            <div id="fileName" onClick={() => document.getElementById("paymentProof").click()}>
                                                <button className="green_btn">Choose File</button>
                                                <span style={{ color: "#777" }}>{fileValue ? fileValue : 'Upload Payment Proof'}</span>
                                            </div>
                                        </div>}
                                        {
                                            fileValue && <div className="img_preview text-center mt-3 ms-auto me-auto df">
                                                <button title="Remove" className="remove_img fa-solid fa-xmark" onClick={removeImg}></button>
                                                <div onClick={togglePreview}>Preview <i className="fa fa-eye"></i></div>
                                                <img src={'data:image/png;base64,' + image} style={{ cursor: "pointer" }} height="100px" width="100px" alt="" onClick={togglePreview} />
                                            </div>
                                        }
                                        <div className="text-center">
                                            <button id="PayNow1" className="popup-button w-50 p-0 ms-auto me-auto" disabled={!(paymentImg)} onClick={() => { pendingConfirmation() }}>Confirm Payment</button>
                                        </div>
                                    </div>
                                </div>}
                        </div>
                    </div>

                    {/* <div className="form-container"> */}

                    {/* <div className="form-group" style={{ position: "relative" }}>
                        <label>UPI ID:</label>
                        <input type="text" placeholder="UPI ID" id="upiId" value={orderDetails?.upiId ? orderDetails?.upiId : "N/A"} disabled />
                        <div style={{ position: "absolute", bottom: "10%", right: "4%" }}>
                            <CopyToClipboard text={orderDetails?.upiId}>
                                <i className="fa-regular fa-copy " style={{ fontSize: "25px", color: "#888", cursor: "pointer" }}></i>
                            </CopyToClipboard>
                        </div>
                    </div> */}

                    {/* <button onClick={()=>{window.location.href="gpay://pay?pa=rminizlp322107@ypbiz&pn=PhonePeMerchant&mc=0000&mode=02&purpose=00&tr=860f9851-cdfc-4a67-9d80-3a90b69ecdad&tn=26739c12-5028-40b5-9f35-c21ee439fa44&am=13.0"}}>Test</button> */}

                    {/* </div> */}

                </div>
                {/* <button id="Cancel" onClick={cancelButton} type="submit">Cancel</button> */}
            </div>

        </>}
    </div>

}

export default UPIPage